var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76 1.73h.13c4.44 0 6.58 1.75 6.95 5.67.04.41-.26.78-.68.82-.4.04-.78-.27-.82-.68-.29-3.14-1.77-4.31-5.46-4.31h-.13c-4.07 0-5.51 1.44-5.51 5.51v6.52c0 4.07 1.44 5.51 5.51 5.51h.13c3.71 0 5.19-1.19 5.46-4.39.05-.41.4-.72.82-.68.42.03.72.4.69.81-.34 3.98-2.49 5.76-6.96 5.76h-.13c-4.91 0-7.01-2.1-7.01-7.01V8.74c0-4.91 2.1-7.01 7.01-7.01Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25h11.38c.41 0 .75.34.75.75s-.34.75-.75.75H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.15 7.9c.19 0 .38.07.53.22l3.35 3.35c.29.29.29.77 0 1.06l-3.35 3.35c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06L20.44 12l-2.82-2.82a.754.754 0 0 1 0-1.06c.14-.15.34-.22.53-.22Z",
    fill: "currentColor"
  })));
};
export { SvgLogout as ReactComponent };